import React, { Component } from 'react'
import '../styles/EncodeAttendance.css'
import APICalendarRequest from '../api/APICalendarRequest'
import APIFarmerRequest from '../api/APIFarmerRequest'
import APIClusterRequest from '../api/APIClusterRequest'
import APIGenericRequest from '../api/APIGenericRequest'
import APISiteRequest from '../api/APISiteRequest'
import APIOrganizationRequest from '../api/APIOrganizationRequest'
import OrgFooter from '../widgets/OrgFooter'
import ActivityIndicator from '../widgets/ActivityIndicator'
import AlertMessage from '../widgets/AlertMessage'
import DropdownWidget from '../widgets/DropdownWidget'
import InputSearchWidget from '../widgets/InputSearchWidget'
import Board from '../widgets/Board'
import Card from '../widgets/Card'

class EncodeAttendance extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			user: JSON.parse(sessionStorage.getItem("user")),
			siteId: localStorage.getItem("siteId"),
			activityId: props.activityId,
			memberCards: [],
			attendedMemberCards: [],
			attendees: [],
			addAttendees: {},
			deleteAttendees: {},
			list: []
		}
		this.getActivityById = this.getActivityById.bind(this)
		this.onSubmit = this.onSubmit.bind(this)
		this.getAllFarmersBySiteId = this.getAllFarmersBySiteId.bind(this)
		this.getAllClustersBySiteId = this.getAllClustersBySiteId.bind(this)
		this.getClusterById = this.getClusterById.bind(this)
		this.searchString = this.searchString.bind(this)
		this.filterFarmerByLocation = this.filterFarmerByLocation.bind(this)
		this.getAllSiteWorkingGroupsBySiteId = this.getAllSiteWorkingGroupsBySiteId.bind(this)
		this.filterMembersByCluster = this.filterMembersByCluster.bind(this)
		this.getAllAECMembersBySiteId = this.getAllAECMembersBySiteId.bind(this)
		this.getAllExtNames = this.getAllExtNames.bind(this)
		this.setDaysAttendedByParticipant = this.setDaysAttendedByParticipant.bind(this)
	}

	onSubmit() {
		this.setState({showActivityIndicator: true})
		const data = {}
		const att = Object.values(this.state.addAttendees)
		if(att.length > 0) {
			data['add'] = {
				attendance: att
			}
		}
		const datt = Object.values(this.state.deleteAttendees)
		if(datt.length > 0) {
			data['delete'] = {
				attendance: datt
			}
		}
		const apiReq = APICalendarRequest.editActivity(this.state.accessToken, data, parseInt(this.state.activityId))
		apiReq.then((response) => {
			if(response.status === "FAILED") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description + ": " + response.results,
					showActivityIndicator: false
				})
				return
			}
			if(response.status === "ERROR") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description + ": " + response.error,
					showActivityIndicator: false
				})
				return
			}
			this.setState({
				showInfoMessage: true,
				aMessage: response.status + "! " + " " + response.description,
				submitAdd: false,
				showActivityIndicator: false
			})
		})
	}

	componentWillMount() {
		this.getActivityById(this.state.activityId)
		this.getAllExtNames()
	}

	componentDidUpdate(prevProps) {
	}

	getActivityById(id) {
		this.setState({showActivityIndicator: true})
		const types = APICalendarRequest.getActivityById(this.state.accessToken, id);
		types.then((response) => {
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return;
			}
			if(response.status === "ERROR") {
				this.setState({showActivityIndicator: false})
				return;
			}
			const attendedMemberCards = []
			const attended = {}
			for(const v of response.results.attendance) {
				if(attended.hasOwnProperty(v.registration_no) || attended.hasOwnProperty(v.member_id)) {
					continue
				}
				let participantId
				switch(response.results.activity.participant_type_id) {
					case 1:
					case 2:
						attended[v.registration_no] = v
						participantId = v.farmer_id
						break
					case 3:
						attended[v.arbo_aec_member_id] = v
						participantId = v.arbo_aec_member_id
						break
					case 4:
						attended[v.id] = v
						participantId = v.member_id
						break
					case 5:
						break
					default:
						title = "FARMERS"
				}
				const mi = (v.middle_name == null)? "": v.middle_name
				const extn = (v.extension_name != null)? v.extension_name: ""
				const name = v.last_name + ", " + v.first_name + " " + extn + " " + mi

				attendedMemberCards.push(<Card id={'card-'+v.id} className="card" key={v.id} onChange={(cardId, val) => {
					this.setDaysAttendedByParticipant(cardId, val)
				}} withCount={true} count={v.no_of_days_attended} draggable={true}>{name.toUpperCase()}</Card>)
			}
			switch(response.results.activity.participant_type_id) {
				case 1:
					var title = "FARMERS"
					this.getAllFarmersBySiteId(attended)
					break
				case 2:
					title = "CLUSTER"
					this.getAllClustersBySiteId(attended)
					break
				case 3:
					title = "ORGANIZATION OFFICERS"
					this.getAllAECMembersBySiteId(attended)
					break
				case 4:
					title = "SITE WORKING GROUP"
					this.getAllSiteWorkingGroupsBySiteId(attended)
					break
				case 5:
					title = "STAKEHOLDERS"
					break
				default:
					title = "FARMERS"
			}
			this.setState({
				title: title,
				participantTypeId: response.results.activity.participant_type_id,
				provinceId: response.results.activity.province_id,
				attendedMemberCards: attendedMemberCards,
				attended: attended,
				noOfDays: response.results.activity.no_of_days,
				showActivityIndicator: false,
			})
		});
	}

	getAllFarmersBySiteId(attended) {
		const allFarmers = APIFarmerRequest.getAllFarmersBySiteId(this.state.accessToken, this.state.siteId)
		allFarmers.then((response) => {
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return
			}
			const memberCards = []
			const list = {}
			response.results.rows.sort((a, b) => {
				return(a.last_name?.localeCompare(b.last_name))
			})
			for(const v of response.results.rows) {
				if(list.hasOwnProperty(v.registration_no) || attended.hasOwnProperty(v.registration_no)) {
					continue
				}
				const mi = (v.middle_name == null)? "": v.middle_name
				const extn = (v.extension_name != null)? v.extension_name: ""
				const name = v.last_name + ", " + v.first_name + " " + extn + " " + mi
				memberCards.push(<Card id={"card-"+v.farmer_id} key={"card-"+v.farmer_id} className="card" withCount={false} draggable={true}>{name.toUpperCase()}</Card>)
				list[v.registration_no] = {name: name.toUpperCase(), participantId: v.farmer_id, details: v}
			}
			this.setState({
				showActivityIndicator: false,
				memberCards: memberCards,
				list: list,
				filteredList: list
			})
		})
	}

	getAllClustersBySiteId(attended) {
		this.setState({showActivityIndicator: true})
		const cluster = APIClusterRequest.getAllClustersBySiteId(this.state.accessToken, this.state.siteId)
		cluster.then(async (response) => {
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return
			}
			const clusterIds = []
			const clusters = []
			clusters.push({id: -1, name: "-- ANY --"})
			for(const v of response.results.rows) {
				clusterIds.push(v.cluster_id)
				clusters.push({id: v.cluster_id, name: v.cluster_name.toUpperCase()})
			}
			const memberCards = []
			const list = {}
			while(clusterIds.length > 0) {
				await this.getClusterById(clusterIds.pop(), (members) => {
					const ms = Object.values(members)
					for(const m of ms) {
						if(list.hasOwnProperty(m.registration_no) || attended.hasOwnProperty(m.registration_no)) {
							continue
						}
						const mi = (m.middle_name == null)? "": m.middle_name
						const extn = (m.extension_name != null)? m.extension_name: ""
						const name = m.last_name + ", " + m.first_name + " " + extn + " " + mi
						memberCards.push(<Card id={"card-"+m.farmer_id} key={"card-"+m.farmer_id} className="card" withCount={false} draggable={true}>{name.toUpperCase()}</Card>)
						list[m.registration_no] = {name: name.toUpperCase(), participantId: m.farmer_id, details: m}
					}
					if(clusterIds.length === 0) {
						this.setState({memberCards: memberCards, list: list, filteredList: list})
					}
				})
			}
			this.setState({clusters: clusters})
		})
	}

	getClusterById(id, callback) {
		const cluster = APIClusterRequest.getClusterById(this.state.accessToken, id)
		cluster.then((response) => {
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return
			}
			if(response.status === "ERROR") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description,
					showActivityIndicator: false
				})
				return
			}
			callback(response.results.members)
		})
	}

	filterMembersByCluster(clusterId) {
		if(clusterId == -1) {
			this.getAllClustersBySiteId(this.state.attended)
			return
		}
		this.getClusterById(clusterId, (members) => {
			const memberCards = []
			const ms = Object.values(members)
			ms.sort((a, b) => {
				return(a.last_name?.localeCompare(b.last_name))
			})
			const filteredList = {}
			for(const m of ms) {
				if(this.state.attended.hasOwnProperty(m.registration_no)) {
					continue
				}
				const mi = (m.middle_name == null)? "": m.middle_name
				const extn = (m.extension_name != null)? m.extension_name: ""
				const name = m.last_name + ", " + m.first_name + " " + extn + " " + mi
				memberCards.push(<Card id={"card-"+m.farmer_id} className="card" draggable={true}
					key={name}>{name.toUpperCase()}</Card>)
				filteredList[m.registration_no] = {name: name.toUpperCase(), participantId: m.farmer_id, details: m}
			}
			this.setState({memberCards: memberCards, filteredList: filteredList})
		})
	}

	getAllSiteWorkingGroupsBySiteId(attended) {
		this.setState({showActivityIndicator: true})
		const apiReq = APISiteRequest.getAllSiteWorkingGroupsBySiteId(this.state.accessToken, this.state.siteId)
		apiReq.then((response) => {
			if(response.status === "ERROR") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description,
					showActivityIndicator: false
				})
				return
			}
			const siteWorkingGroup = {}
			for(const v of response.results) {
				siteWorkingGroup[v.member_id] = v
			}
			const memberCards = []
			const list = {}
			const swg = Object.values(siteWorkingGroup)
			swg.sort((a, b) => {
				return(a.last_name?.localeCompare(b.last_name))
			})
			for(const v of swg) {
				if(list.hasOwnProperty(v.member_id) || attended.hasOwnProperty(v.member_id)) {
					continue
				}
				const mi = (v.middle_name == null)? "": v.middle_name
				const extn = (v.extension_name != null)? v.extension_name: ""
				const name = v.last_name + ", " + v.first_name + " " + extn + " " + mi
				memberCards.push(<Card id={"card-"+v.member_id} key={"card-"+v.member_id} className="card" draggable={true}>{name.toUpperCase()}</Card>)
				list[name] = {name: name.toUpperCase(), participantId: v.member_id, details: v}
			}
			this.setState({memberCards: memberCards, list: list, filteredList: list})
		})
	}

	getAllAECMembersBySiteId(attended) {
		this.setState({showActivityIndicator: true})
		const obi = APIOrganizationRequest.getAECommitteeByArboId(this.state.accessToken, 27)
		obi.then((response) => {
			if(response.status === "ERROR") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description,
					showActivityIndicator: false
				})
				return
			}
			response.results.AECMember.sort((a, b) => {
				return(a.last_name?.localeCompare(b.last_name))
			})
			const aecMembers = {}
			for(const v of response.results.AECMember) {
				aecMembers[v.arbo_aec_member_id] = v
			}
			const memberCards = []
			const list = {}
			const aec = Object.values(aecMembers)
			for(const v of aec) {
				if(list.hasOwnProperty(v.arbo_aec_member_id) || attended.hasOwnProperty(v.arbo_aec_member_id)) {
					continue
				}
				const mi = (v.middle_name == null)? "": v.middle_name
				const extn = (v.extension_name != null)? v.extension_name: ""
				const name = v.last_name + ", " + v.first_name + " " + extn + " " + mi
				memberCards.push(<Card id={"card-"+v.arbo_aec_member_id} className="card"
					draggable={true} key={"card-"+v.arbo_aec_member_id}>{name.toUpperCase()}</Card>)
				list[v.arbo_aec_member_id] = {name: name.toUpperCase(), participantId: v.arbo_aec_member_id, details: v}
			}
			this.setState({memberCards: memberCards, list: list, filteredList: list})
		})
	}

	getAllExtNames() {
		const ext = APIGenericRequest.getAllExtensionNames(this.state.accessToken)
		ext.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			c.push({id: 0, name: "N/A"})
			for(const v of response.results.rows) {
				c.push({id: v.extension_id, name: v.name})
			}
			this.setState({extName: c})
		})
	}

	filterFarmerByLocation(cityId, barangayId) {
		const memberCards = []
		const filteredList = {}
		Object.entries(this.state.list).map(([k, v]) => {
			if(v.details.barangay_id == barangayId) {
				memberCards.push(<Card id={"card-"+v.details.farmer_id} className="card"
					draggable={true} key={v.name}>{v.name.toUpperCase()}</Card>)
				filteredList[k] = v
			}
			else if(v.details.city_id == cityId && barangayId == -1) {
				memberCards.push(<Card id={"card-"+v.details.farmer_id} className="card"
					draggable={true} key={v.name}>{v.name.toUpperCase()}</Card>)
				filteredList[k] = v
			}
			else if((cityId == -1 || cityId == null) && (barangayId == -1 || barangayId == null)) {
				memberCards.push(<Card id={"card-"+v.details.farmer_id} className="card"
					draggable={true} key={v.name}>{v.name.toUpperCase()}</Card>)
				filteredList[k] = v
			}
		})
		this.setState({memberCards: memberCards, filteredList: filteredList})
	}

	searchString(str) {
		if(this.state.filteredList == null || str == null) {
			return
		}
		this.setState({memberCards: []})
		const memberCards = []
		Object.entries(this.state.filteredList).map(([k, v]) => {
			if(v.name.toLowerCase().includes(str.toLowerCase())) {
				memberCards.push(<Card id={"card-"+v.participantId} className="card"
					draggable={true} key={Math.random()}>{v.name.toUpperCase()}</Card>)
			}
		})
		this.setState({memberCards: memberCards})
	}

	setDaysAttendedByParticipant(id, days) {
		this.state.addAttendees[id].no_of_days_attended = days
	}

	render() {
		const view = <div id="encode-attendance">
			<div className="title-bar">ENCODE ATTENDANCE</div>
			{this.state.participantTypeId != 5 && <div id="ea-cell1">Instruction: Double click or drag the present member or officer's name to the ATTENDEES column</div>}
			{this.state.participantTypeId == 5 && <div id="ea-cell1">Instruction: Enter the details of the member or the officer's name to be added in the ATTENDEES column</div>}
			<div id="ea-boards">
				<div id="ea-cell2">
					<div style={{'margin-bottom': '15px', font: '9pt roboto-bold'}}>{this.state.title}</div>
					{this.state.participantTypeId == 1 && <FarmerFilter provinceId={this.state.provinceId}
						data={this.state.farmers}
						onSearchString={this.searchString}
						onSearchClick={this.filterFarmerByLocation} />}
					{this.state.participantTypeId == 2 && <ClusterFilter clusters={this.state.clusters}
						onClusterChanged={this.filterMembersByCluster}
						onSearchString={this.searchString} />}
					{this.state.participantTypeId == 3 && <CommonFilter clusters={this.state.clusters}
						onSearchString={this.searchString} />}
					{this.state.participantTypeId == 4 && <CommonFilter clusters={this.state.clusters}
						onSearchString={this.searchString} />}
					{this.state.participantTypeId == 5 && <div id="ea-stakeholder">
						<input type="text" placeholder="FIRST NAME"
							onFocus={(e) => { e.target.value = ""}}
							onChange={(e) =>{ this.setState({firstName: e.target.value })
						}} />
						<input type="text" placeholder="MIDDLE NAME"
							onFocus={(e) => { e.target.value = ""}}
							onChange={(e) =>{ this.setState({middleName: e.target.value })
						}} />
						<input type="text" placeholder="LAST NAME"
							onFocus={(e) => { e.target.value = ""}}
							onChange={(e) =>{ this.setState({lastName: e.target.value })
						}} />
						<div><button onClick={() => {
							this.state.list.push({
								"first_name": (this.state.firstName == null)? "": this.state.firstName,
								"middle_name": (this.state.middleName == null)? "": this.state.middleName,
								"last_name": (this.state.lastName == null)? "": this.state.lastName,
								"no_of_days_attended": "1"
							})
							const memberCards = []
							for(const v of this.state.list) {
								const name = v.first_name + " " + v.middle_name + " " + v.last_name
								memberCards.push(<Card id={"card-"+Math.random()} className="card" draggable={true}>{name.toUpperCase()}</Card>)
							}
							this.setState({
								attendedMemberCards: memberCards,
								firstName: null,
								middleName: null,
								lastName: null,
								ext: "EXT",
								attendees: this.state.list
							})
						}}>ADD</button></div>
					</div>}

					<Board id="ea-board-0" className="board" onCardAdded={(card) => {
						const cid = card.id.split('-')
						this.state.deleteAttendees[card.id] = {
							id: cid[1]
						}
						delete this.state.addAttendees[card.id]
					}} list={this.state.memberCards}
					onAdded={(cardId, card) =>{
						const farmerCards = []
						const filteredList = {}
						farmerCards.push(<Card id={cardId} className="card" withCount={false}
								key={Math.random()} draggable={!this.state.isViewDetails}>{card.innerText}</Card>)
						Object.entries(this.state.filteredList).map(([k, v]) => {
							farmerCards.push(<Card id={'card-'+v.details.farmer_id} className="card" withCount={false}
								key={Math.random()} draggable={!this.state.isViewDetails}>{v.name}</Card>)
								filteredList[k] = v
						})
						const attendedMemberCards = []
						this.state.attendedMemberCards.map((item, i) => {
							if(item.props.id != cardId) {
								attendedMemberCards.push(item)
							}
						})
						this.setState({
							memberCards: farmerCards,
							filteredList: filteredList,
							attendedMemberCards: attendedMemberCards
						})
					}}></Board>
				</div>
				<div id="ea-cell3">
					<div style={{'margin-bottom': '15px', font: '9pt roboto-bold'}}>ATTENDEES</div>
					<Board id="ea-board-1" className="board" onCardAdded={(card) => {
						const pid = card.id.split('-')
						this.state.addAttendees[card.id] = {
							participant_type_id: this.state.participantTypeId,
							participant_id: pid[1],
							no_of_days_attended: "1"
						}
						let attendedMemberCards = this.state.attendedMemberCards
						if(attendedMemberCards == null) {
							attendedMemberCards = []
						}
						attendedMemberCards.push(<Card id={card.id} onChange={(cardId, val) => {
								this.setDaysAttendedByParticipant(cardId, val)
							}}
							withCount={true}
							maxDays={this.state.noOfDays}
							className="card"
							key={Math.random()}
							draggable={!this.state.isViewDetails}>
								{card.name}
							</Card>)
						const farmerCards = []
						const filteredList = {}
						Object.entries(this.state.filteredList).map(([k, v]) => {
							if(!card.id.includes(v.details.farmer_id)) {
								farmerCards.push(<Card id={'card-'+v.details.farmer_id} className="card"
									key={Math.random()} draggable={!this.state.isViewDetails}>{v.name}</Card>)
									filteredList[k] = v
							}
						})
						this.setState({
							memberCards: farmerCards,
							attendedMemberCards: attendedMemberCards,
							filteredList: filteredList
						})
					}} list={this.state.attendedMemberCards} withCardCount={true}></Board>
				</div>
			</div>
			<div id="ea-footer"><OrgFooter submit={this.onSubmit} showSubmit={(this.state.user.role_id == 3)? true: false} /></div>
			{this.state.showInfoMessage == true && <AlertMessage type="information" text={this.state.aMessage}
				onClick={() => {
					this.setState({showInfoMessage: false})
			}} />}
			{this.state.showWarningMessage == true && <AlertMessage type="warning" text={this.state.aMessage}
				onClick={() => { this.setState({showWarningMessage: false}) }} />}
			{this.state.showActivityIndicator && <ActivityIndicator showActivityIndicator={this.state.showActivityIndicator} />}
		</div>
		return(view)
	}
}

class FarmerFilter extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			city: "-- ANY --",
			barangay: "-- ANY --",
			barangayId: -1,
			cityId: -1
		}
		this.getAllCitiesByProvinceId = this.getAllCitiesByProvinceId.bind(this)
		this.getAllBarangaysByCityId = this.getAllBarangaysByCityId.bind(this)
		this.onSearchEvent = this.onSearchEvent.bind(this)
	}

	componentWillMount() {
		this.getAllCitiesByProvinceId(this.props.provinceId)
	}

	componentDidUpdate(prevProps) {
		if(this.props.provinceId != prevProps.provinceId) {
			this.getAllCitiesByProvinceId(this.props.provinceId)
		}
	}

	getAllCitiesByProvinceId(id) {
		const city = APIGenericRequest.getAllCitiesByProvinceId(this.state.accessToken, parseInt(id))
		city.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			c.push({id: -1, name: "-- ANY --"})
			for(const v of response.results.rows) {
				c.push({id: v.city_id, name: v.name})
			}
			this.setState({
				cities: c,
				city: "-- ANY --",
				barangay: "-- ANY --"
			})
		})
	}

	getAllBarangaysByCityId(id) {
		const city = APIGenericRequest.getAllBarangaysByCityId(this.state.accessToken, id);
		city.then((response) => {
			if(response.status === "FAILED") {
				return;
			}
			const c = [];
			c.push({id: -1, name: "-- ANY --"})
			for(const v of response.results.rows) {
				c.push({id: v.barangay_id, name: v.name});
			}
			this.setState({barangays: c});
		});
	}

	onSearchEvent(value) {
		this.props.onSearchString(value)
	}

	render() {
		const view = <div className="ea-filter">
			<div>
				<div id="ea-city">
					<div style={{'margin-bottom': '5px'}}>Municipality / City</div>
					<DropdownWidget list={this.state.cities} placeholder={this.state.city} cStyle={{"width": "100%"}}
						onItemSelected={(id, val) => {
							this.setState({
								cityId: id,
								barangayId: -1,
								barangay: "-- ANY --",
								barangays: []
							});
							this.getAllBarangaysByCityId(id)
						}} />
				</div>
				<div id="ea-barangay">
					<div style={{'margin-bottom': '5px'}}>Barangay</div>
					<DropdownWidget list={this.state.barangays} placeholder={this.state.barangay} cStyle={{"width": "100%"}}
						onItemSelected={(id, val) => {
							this.setState({barangayId: id, barangay: val})
						}} />
				</div>
				<div>
					<br/>
					<button id="ea-search" style={{'margin-top': '4px'}} onClick={(e) => {
						this.props.onSearchClick(this.state.cityId, this.state.barangayId)
					}}>SEARCH</button>
				</div>
			</div>
			<div><InputSearchWidget placeholder="SEARCH BY NAME OR REGISTRATION ID" cStyle={{'width': '100%', 'margin-top': '10px'}}
				onSearchClick={(value) => {
					this.onSearchEvent(value)
				}}
				onEnterPress={(value) => {
					this.onSearchEvent(value)
				}} />
			</div>
		</div>
		return(view)
	}
}

class ClusterFilter extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			siteId: localStorage.getItem("siteId"),
			clusters: props.clusters,
			cluster: "-- ANY --"
		}
		this.onSearchEvent = this.onSearchEvent.bind(this)
	}

	componentDidUpdate(prevProps) {
		if(this.props.clusters != prevProps.clusters) {
			this.setState({clusters: this.props.clusters})
		}
	}

	onSearchEvent(value) {
		this.props.onSearchString(value)
	}

	render() {
		const view = <div className="ea-filter">
			<DropdownWidget list={this.state.clusters} placeholder={this.state.cluster} cStyle={{"width": "100%"}}
				onItemSelected={(id, val) => {
					this.props.onClusterChanged(id)
				}} />
			<div><InputSearchWidget placeholder="SEARCH BY NAME" cStyle={{'width': '100%', 'margin-top': '10px'}}
				onSearchClick={(value) => {
					this.onSearchEvent(value)
				}}
				onEnterPress={(value) => {
					this.onSearchEvent(value)
				}} />
			</div>
		</div>
		return(view)
	}
}

class CommonFilter extends Component
{
	constructor(props) {
		super(props)
		this.onSearchEvent = this.onSearchEvent.bind(this)
	}

	onSearchEvent(value) {
		this.props.onSearchString(value)
	}

	render() {
		const view = <div className="ea-filter">
			<div><InputSearchWidget placeholder="SEARCH BY NAME" cStyle={{'width': '100%', 'margin-top': '10px'}}
				onSearchClick={(value) => {
					this.onSearchEvent(value)
				}}
				onEnterPress={(value) => {
					this.onSearchEvent(value)
				}} />
			</div>
		</div>
		return(view)
	}
}

export default EncodeAttendance
